import React from 'react';
import PageHeader from './PageHeader';

/**
 * PageLayout — B2B page shell
 *
 * Wraps any page content with a consistent header and constrained container.
 * Ensures uniform background, max-width, and spacing across all RBAC pages.
 *
 * Usage:
 *   <PageLayout header={{ title: "Área do Treinador", subtitle: "..." }}>
 *     {content}
 *   </PageLayout>
 */
export default function PageLayout({ header, children }) {
  return (
    <div className="min-h-screen bg-white">
      {header && <PageHeader {...header} />}
      <div className="mx-auto w-full max-w-7xl px-6 py-6">
        {children}
      </div>
    </div>
  );
}
